<!-- eslint-disable -->
<template>
  <CommonPages id="blog" :class="['blog']" titlePrefix="Blog">
    <div class="blog-container">
      <!-- 顶部标题区域 -->
      <div class="blog-header" :class="[deviceType]">
        <div class="blog-title">Naming Stories & Inspiration</div>
        <div class="blog-subtitle">Dive into expert tips, cultural deep-dives, and modern naming
          insights to guide your baby name journey.</div>
      </div>

    </div>

    <!-- 博客卡片列表 -->
    <div class="blog-cards" :class="[deviceType]">
      <template v-for="(card, index) in filteredBlogCards">
        <div class="blog-card-link" :key="index" @click="navigateToBlog(card)"
          @mouseenter="hoveredCardIndex = index" @mouseleave="hoveredCardIndex = null">
          <div class="blog-card" :class="{ 'hovered': hoveredCardIndex === index }">
            <div class="card-image-container">
              <img class="card-image" :src="card.image" alt="blog image" />
            </div>
            <div class="card-info">
              <div class="card-title">{{ card.title }}</div>
              <div class="card-author">
                <div class="author-name">{{ card.author }}</div>
              </div>
            </div>
          </div>
        </div>

        <AdComponent
          v-if="deviceType === 'mobile' && index === 1 || deviceType != 'mobile' && index === 3"
          :key="'ads-blog-1'"
          v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.blog_1" ref="ads-blog-1"
          class="ad-width-100 " :ads="adsensConfig?.blog_1" :showDebug="showDebug" />
        <AdComponent
          v-if="deviceType === 'mobile' && index === 5 || deviceType !== 'mobile' && index === 11"
          :key="'ads-blog-2'"
          v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.blog_2" ref="ads-blog-2"
          class="ad-width-100 " :ads="adsensConfig?.blog_2" :showDebug="showDebug" />
        <AdComponent v-if="deviceType === 'mobile' && index === 5" :key="'ads-blog-3'"
          v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.blog_3" ref="ads-blog-3"
          class="ad-width-100 " :ads="adsensConfig?.blog_3" :showDebug="showDebug" />
      </template>

    </div>

    <!-- 组合模块 -->
    <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
      <div class="section-header">
        <div class="section-title">Combinations</div>
      </div>
      <div class="combinations-container">
        <div class="combination-row">
          <div class="combination-card-link" v-for="(combo, index) in combinations" :key="index"
            @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
            @mouseleave="hoveredCombination = null">
            <div class="combination-card" :class="{'hovered': hoveredCombination === index}">
              <div class="combination-text">
                {{ combo.title }}
              </div>
              <div class="see-more-button">
                <span>See More</span>
                <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow"
                  class="arrow-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索过滤区域 -->
    <section class="search-sec-row" :class="[deviceType]">
      <!-- 搜索过滤区域 -->
      <div class="section-header" :class="[deviceType]">
        <div class="section-title">Search by Filter</div>
      </div>

      <div class="names-filter" :class="[deviceType]">
        <SearchFilter />
      </div>
    </section>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import allBlogs from '@/data/blogs.json'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'

export default {
  name: 'Blog',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      hoveredCardIndex: null,
      hoveredCombination: null,
      isGenerateHovered: false,
      isResetHovered: false,
      defaultFilters: {
        gender: 'all',
        az: 'all',
        style: 'vintage',
        meaning: 'all',
        syllables: '2',
        origin: 'all'
      },
      filters: {
        gender: 'all',
        az: 'all',
        style: 'all',
        meaning: 'all',
        syllables: 'all',
        origin: 'all'
      },
      azOptions: [
        { value: 'all', label: 'All' },
        { value: 'a', label: 'A' },
        { value: 'b', label: 'B' },
        { value: 'c', label: 'C' }
      ],
      syllablesOptions: [
        { value: 'all', label: 'All' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' }
      ],
      blogCards: [],
      combinations: []
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
      "adsensConfig",
      'adPosConfig',
      'showDebug',
      'gender',
      'style',
      'meaning'
    ]),
    pageTitle () {
      return 'Insights - Blog Articles';
    },
    pageDescription () {
      const origin = this.domainConfig?.origin || '';
      return `Read in-depth blog articles about ${origin} naming traditions, meanings, and naming trends.`;
    },
    genderOptions () {
      if (!this.gender || this.gender.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.gender.map(item => ({ label: item, value: item.toLowerCase() }))];
    },
    styleOptions () {
      if (!this.style || this.style.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.style.map(item => ({ label: item, value: item.toLowerCase() }))];
    },
    meaningOptions () {
      if (!this.meaning || this.meaning.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.meaning.map(item => ({ label: item, value: item.toLowerCase() }))];
    },
    filteredBlogCards () {
      if (this.domainConfig && this.domainConfig.blog && this.domainConfig.blog.length) {
        return this.domainConfig.blog
          .map(id => allBlogs.find(blog => String(blog.id) === String(id)))
          .filter(blog => blog); // 过滤掉未找到的博客
      }
      return allBlogs; // 如果没有配置，返回所有博客
    }
  },
  methods: {
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.defaultFilters));
    },
    navigateToBlog (card) {
      if (card && card.id) {
        // 将标题转换为URL友好的格式
        const formattedTitle = card.routename || card.title
          .toLowerCase()
          .replace(/[^\w\s-]/g, '') // 移除特殊字符
          .replace(/\s+/g, '-'); // 将空格替换为连字符

        this.$router.push(`/blog/${formattedTitle}/${card.id}`);
      }
    },
    async fetchCombinations () {
      const origin = this.domainConfig?.origin || '';
      try {
        const params = { origin };
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
        this.combinations = [];
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    }
  },
  async mounted () {
    this.fetchCombinations()
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.blog {
	background-color: #000;

	.blog-container {
		background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0) 53.34%, #000 100%), linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
		width: 100%;
		padding-bottom: rem(52);
	}

	.blog-header {
		padding: rem(80) rem(180);
		color: #fff;

		.blog-title {
			font-size: rem(52);
			font-weight: 900;
			line-height: rem(60);
			margin-bottom: rem(16);
		}

		.blog-subtitle {
			font-size: rem(20);
			line-height: rem(28);
			max-width: rem(800);
		}
	}

	.blog-cards {
		padding: rem(40) rem(180);
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(24);

		.blog-card-link {
			text-decoration: none;
			padding: rem(2);
			border-radius: rem(16);
			background: transparent;
			transition: all 0.3s ease;
			&:hover {
				background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
			}
		}

		.blog-card {
			background: rgb(26 26 26);
			border-radius: rem(14);
			cursor: pointer;
			display: flex;
			flex-direction: column;
			transition: border-color 0.3s ease;
			height: 100%;

			.card-image-container {
				padding: rem(8);
				padding-bottom: 0;

				.card-image {
					width: 100%;
					height: rem(158);
					border-radius: rem(12);
					object-fit: cover;
				}
			}

			.card-info {
				padding: rem(16) rem(16) rem(16);
				display: flex;
				flex-direction: column;
				gap: rem(12);
				// height: rem(88);
				box-sizing: border-box;
				justify-content: space-between;

				.card-title {
					color: #fff;
					font-size: rem(14);
					font-weight: 700;
					line-height: rem(20);
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.author-name {
					color: #fff;
					font-size: rem(12);
					font-style: italic;
					opacity: 0.8;
				}
			}
		}
	}

	.combinations-section {
		padding: rem(40) rem(180) rem(80) rem(180);
		display: flex;
		flex-direction: column;
		gap: rem(24);

		.section-header .section-title {
			color: #ffffff;
			font-size: rem(24);
			font-weight: 900;
		}

		.combinations-container {
			.combination-row {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: rem(24);
			}

			.combination-card-link {
				text-decoration: none;
				padding: rem(2);
				border-radius: rem(16);
				background: transparent;
				transition: all 0.3s ease;
				&:hover {
					background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
				}
			}

			.combination-card {
				background: rgb(26, 26, 26);
				border-radius: rem(14);
				padding: rem(24);
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: rem(172);
				box-sizing: border-box;
				cursor: pointer;

				.combination-text {
					color: #ffffff;
					font-size: rem(18);
					line-height: rem(24);
					font-weight: 700;
				}

				.see-more-button {
					background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
					border-radius: rem(8);
					padding: rem(8) rem(16);
					display: flex;
					align-items: center;
					justify-content: center;
					gap: rem(8);
					width: rem(100);
					height: rem(28);
					box-sizing: border-box;

					span {
						color: #ffffff;
						font-size: rem(12);
						font-weight: 700;
					}

					img {
						width: rem(6);
						height: rem(10);
						filter: brightness(0) invert(1);
					}
				}
			}
		}

		&.mobile {
			padding: rem(40) 0;
			.combinations-container {
				.combination-row {
					display: flex;
					overflow-x: auto;
					gap: rem(16);
					padding: 0 rem(16);
					margin: 0 rem(-16);
					&::-webkit-scrollbar {
						display: none;
					}
					-ms-overflow-style: none;
					scrollbar-width: none;
				}
				.combination-card-link {
					flex-shrink: 0;
					width: rem(280);
				}
			}
		}
	}

	.search-sec-row {
		padding: 0 rem(180) rem(80);

		.section-header {
			margin-bottom: rem(24);

			.section-title {
				color: #fff;
				font-size: rem(24);
				font-weight: 900;
			}
		}
	}

	&.detect_deviece_mobile {
		.blog-header {
			padding: rem(32) rem(16);
			.blog-title {
				font-size: rem(32);
				line-height: rem(40);
			}
			.blog-subtitle {
				font-size: rem(16);
				line-height: rem(24);
			}
		}
		.blog-cards {
			padding: rem(32) rem(16);
			grid-template-columns: repeat(2, 1fr);
			gap: rem(12) rem(15);
		}
		.section-header {
			padding: rem(40) rem(16) rem(24);
		}
		.combinations-section {
			padding: rem(40) rem(16);
			.combinations-container .combination-row {
				grid-template-columns: 1fr;
			}
		}
		.names-filter {
			padding: 0 rem(16) rem(40);
		}
		.search-sec-row {
			padding: 0 rem(16) rem(40);
		}
	}
}
</style> 